export default __webpack_public_path__ + "static/media/bottom_bg_product.fbc32914.png";